export default __webpack_public_path__ + "static/media/background-icons.4106fe9d.png";